import { useRouter } from 'next/router';

export default function useListingIdFromRoute(): number {
  const router = useRouter();

  return Number(router.query.id);
}
